import { render, staticRenderFns } from "./ProcessTabs.vue?vue&type=template&id=2c052416&"
import script from "./ProcessTabs.vue?vue&type=script&lang=js&"
export * from "./ProcessTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports